import http from 'plugins/axios';

export default {
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getStatistics({uid, from, to, coinType, page, size}) {
    return http.get({
      url: '/admin/statistics/user',
      data: {
        uid,
        coinType,
        from,
        to,
        page,
        size
      }
    });
  }
};
